//TODO:  Do we need substate for this Task Object State???   Split into SubState like Contract?

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppService } from '@Core/services/proprietary/app.service';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { CostType } from '../contract/contract-object.types';
import { ResetState, SetObjectState } from './productline-config-object.actions';

export interface ProductLineConfigObjectStateModel {
    entities: any;
    productLineConfig: any;
}

const ProductLineConfigObjectStateDefaults: ProductLineConfigObjectStateModel = {
    entities: {},
    productLineConfig: {}
};

@State<ProductLineConfigObjectStateModel>({
    name: 'ProductLineConfigObjectState',
    defaults: ProductLineConfigObjectStateDefaults
    //children: [ContractState, LocationState, ProductState, ArticleState, EntityState, AddressState, PhoneState]
})
@Injectable()
export class ProductLineConfigObjectState {
    constructor(private app: AppService, private helper: StateHelperService) { }

    @Selector()
    static entities(state: ProductLineConfigObjectStateModel) {
        let tempEntities = { ...state.entities };
        tempEntities.ProductLineConfig = state.productLineConfig;
        return tempEntities;
    }

    @Selector()
    static productLine(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string) => {
            if (state.productLineConfig[lineCode.toLowerCase()]) {
                return state.productLineConfig[lineCode.toLowerCase()];
            }
            return {};
        };
    }

    @Selector()
    static productLineExists(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string) => {
            if (state.productLineConfig[lineCode.toLowerCase()]) {
                return true;
            }
            return false;
        };
    }

    @Selector()
    static products(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string) => {
            lineCode = lineCode.toLowerCase();
            if (state.productLineConfig[lineCode]) {
                return state.productLineConfig[lineCode].Products;
            }
            return [];
        };
    }

    @Selector()
    static productsAsCodeSet(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string, costType?: CostType) => {
            let result: any = [];
            lineCode = lineCode.toLowerCase();
            if (state.productLineConfig[lineCode]) {
                for (var i in state.productLineConfig[lineCode].Products.Product) {
                    if (!costType || state.productLineConfig[lineCode].Products.Product[i].Product_Cost_Type == costType)
                        result.push({
                            Code: state.productLineConfig[lineCode].Products.Product[i].Product_Code,
                            Code_Desc: state.productLineConfig[lineCode].Products.Product[i].Product_Desc
                        });
                }
            }
            return result;
        };
    }

    @Selector()
    static contractProductsByLevelAndCostType(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string, level: string, costType: CostType) => {
            let result: any = [];
            lineCode = lineCode.toLowerCase();
            if (
                state.productLineConfig[lineCode] &&
                state.productLineConfig[lineCode].Products &&
                state.productLineConfig[lineCode].Products.Product
            ) {
                let products = state.productLineConfig[lineCode].Products.Product;
                for (var i in products) {
                    if (costType == 'A' || products[i].Product_Cost_Type == costType) {
                        if (products[i].Contract_Use_Level == 'B' || products[i].Contract_Use_Level == level) {
                            result.push(products[i]);
                        }
                    }
                }
            }
            return result;
        };
    }

    @Selector()
    static productsByExclusivityGroup(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string, group: string) => {
            let result: any = [];
            lineCode = lineCode.toLowerCase();
            if (
                state.productLineConfig[lineCode] &&
                state.productLineConfig[lineCode].Products &&
                state.productLineConfig[lineCode].Products.Product
            ) {
                let products = state.productLineConfig[lineCode].Products.Product;
                for (var i in products) {
                    if (
                        products[i].Exclusivity_Group == group &&
                        ['B', 'A'].includes(products[i].Contract_Use_Level) &&
                        products[i].Shared_Definition_Ind != 'Y'
                    ) {
                        result.push(products[i]);
                    }
                }
            }
            return result;
        };
    }

    @Selector()
    static productConfig(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string, productCode: string) => {
            let result: any = {};
            lineCode = lineCode.toLowerCase();
            if (
                state.productLineConfig[lineCode] &&
                state.productLineConfig[lineCode].Products &&
                state.productLineConfig[lineCode].Products.Product
            ) {
                let products = state.productLineConfig[lineCode].Products.Product;
                for (var i in products) {
                    if (products[i].Product_Code == productCode) {
                        result = products[i];
                        break;
                    }
                }
            }
            return result;
        };
    }

    @Selector()
    static programsByLineCode(state: ProductLineConfigObjectStateModel) {
        return (lineCode: string) => {
            let result: any = [];
            lineCode = lineCode.toLowerCase();
            if (
                state.productLineConfig[lineCode] &&
                state.productLineConfig[lineCode].Programs &&
                state.productLineConfig[lineCode].Programs.Program
            ) {
                for (var i in state.productLineConfig[lineCode].Programs.Program) {
                    result.push(state.productLineConfig[lineCode].Programs.Program[i].Program_Code);
                }
            }
            return result;
        };
    }
    //TODO: selector for just sublines?

    @Action(SetObjectState)
    setObjectState(sc: StateContext<ProductLineConfigObjectStateModel>, action: SetObjectState) {
        const state = sc.getState();

        // copy references to raw normalized entities and then remove the entities that have thier own state
        let entities = { ...action.entities };
        delete entities.ProductLineConfig;

        // Make sure that entities "selector" get entities from all substates.   if a new substate is added here then we need to add to the selector
        sc.setState({
            entities: entities,
            productLineConfig: { ...state.productLineConfig, ...action.entities.ProductLineConfig }
        });
    }

    @Action(ResetState)
    resetState(sc: StateContext<ProductLineConfigObjectStateModel>, action: ResetState) {
        sc.setState({
            entities: {},
            productLineConfig: {}
        });
    }
}
